<script lang="js">
import { RouterLink } from 'vue-router';
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import NotificationDropdown from '../NotificationDropdown.vue';
import AuthenticatedProfileImage from './AuthenticatedProfileImage.vue';

export default {
  name: 'AppNavbar',
  data() {
    return {
      logger:null,
      isDevelopment: process.env.NODE_ENV === "development",
    }
  },
  computed: {
    ...mapGetters(["getUser", "getApplication", "getStudent"]),
    user() {
      return this.getUser || {};
    },
    userData() {
      return { ...this.user, ...(this.getApplication || {}), ...(this.getStudent || {}) };
    },
    menuItems() {
      // Use different routes for development vs production
      if (this.isDevelopment) {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/app" },
          { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/app/academics" },
          { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/app/resources" },
          { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/app/finance" },
                      { name: "Settings", label: "Settings", icon: "bi bi-gear-fill", route: "/app/settings" },
        ];
      } else {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/dashboard" },
          { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/academics" },
          { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/resources" },
          { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/finance" },
                        { name: "Settings", label: "Settings", icon: "bi bi-gear-fill", route: "/settings" },
        ];
      }
    }
  },
      created() {
    // Create a logger instance for this component
    this.logger = this.$createLogger('AppNavbar');
  },
  methods: {
    async logout() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will be logged out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Logout",
      });

      if (result.isConfirmed) {
        // Use the new logout action that handles cookie clearing
        await this.$store.dispatch("logout");
      this.logger.info("User logged out");

        Swal.fire("Logged Out!", "You have been successfully logged out.", "success");
        this.$urlHelper.goToPortal('/'); // Redirect to portal login
      }
    },
    isActive(routePath) {
      return this.$route.path === routePath;
    },
    closeNavbar() {
      // Close the main navbar collapse on mobile
      const navbarCollapse = document.getElementById('navbarSupportedContent');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const bsCollapse = this.$bootstrap.Collapse.getInstance(navbarCollapse);
        if (bsCollapse) {
          bsCollapse.hide();
        }
      }
    },
    handleNavigation() {
      // Close navbar when navigation occurs
      this.closeNavbar();
    }
  },
  mounted() {
  },
  components: { RouterLink, NotificationDropdown, AuthenticatedProfileImage },
}
</script>

<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark fixed-top"
    style="background-color: #181c1f !important"
  >
    <div class="container-fluid">
      <RouterLink
        class="navbar-brand d-flex align-items-center gap-2"
        :to="{ name: 'app' }"
      >
        <img
          src="@/assets/logo.png"
          alt="Logo"
          width="56.26"
          height="40"
          class="d-inline-block align-middle"
        />
        <h6 class="fw-bold text-uppercase m-0">First City Polytechnic</h6>
      </RouterLink>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-flex d-lg-none">
          <li
            v-for="item in menuItems"
            :key="item.name"
            class="nav-item"
            :class="{ active: $route.path === item.route }"
          >
            <RouterLink
              class="nav-link d-flex align-items-center"
              :to="item.route"
              @click="handleNavigation"
            >
              <i :class="item.icon + ' fs-4'"></i>
              <span class="small ms-2">{{ item.label }}</span>
            </RouterLink>
          </li>
        </ul>
        <form class="me-5 d-flex flex-grow-1" role="search">
          <input
            class="form-control me-2 w-100 bg-dark border-dark text-white"
            type="search"
            placeholder="Search"
            aria-label="Search"
          />
        </form>

        <NotificationDropdown :user="userData" />

        <div class="mb-lg-0 d-flex">
          <AuthenticatedProfileImage
            alt="User"
            :size="40"
            class="me-2 rounded-circle border border-white"
          />
          <div class="d-flex flex-column text-start">
            <span class="text-white text-capitalize" v-if="userData">
              {{ userData.firstName }} {{ userData.lastName }}
            </span>
            <span class="text-light small">
              {{ userData.applicationNumber }}
            </span>
          </div>
          <a class="btn btn-link text-danger ms-3" @click="logout">
            <i class="bi bi-box-arrow-right fs-5"></i>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<style scoped></style>
